import React from "react";
import { useUID } from "react-uid";

export default function LongRight({ color, size }) {
  const id = useUID();
  const svgHeight = size === "sm" ? 7 : 14;
  const svgWidth = size === "sm" ? 21 : 42;

  return (
    <svg
      width={svgWidth}
      height={svgHeight}
      viewBox="0 0 42 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M29.0025,-1.0025 C28.7425,-1.0025 28.4925,-1.1025 28.2925,-1.2925 L24.0025,-5.5925 L24.0025,31.9975 C24.0025,32.5475 23.5525,32.9975 23.0025,32.9975 C22.4525,32.9975 22.0025,32.5475 22.0025,31.9975 L22.0025,-5.5925 L17.7125,-1.2925 C17.3225,-0.9025 16.6825,-0.9025 16.2925,-1.2925 C15.9025,-1.6825 15.9025,-2.3225 16.2925,-2.7125 L22.2925,-8.7125 C22.3825,-8.8025 22.4925,-8.8725 22.6125,-8.9225 C22.6625,-8.9425 22.7025,-8.9625 22.7525,-8.9625 C22.9125,-9.0125 23.0925,-9.0125 23.2525,-8.9625 C23.3025,-8.9625 23.3425,-8.9425 23.3925,-8.9225 C23.5125,-8.8725 23.6225,-8.8025 23.7125,-8.7125 L29.7125,-2.7125 C30.1025,-2.3225 30.1025,-1.6825 29.7125,-1.2925 C29.5125,-1.1025 29.2625,-1.0025 29.0025,-1.0025 Z"
          id={id}
        ></path>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-750.000000, -1159.000000)">
          <g transform="translate(748.000000, 1154.000000)">
            <rect x="0" y="0" width="46" height="24"></rect>
            <mask id="mask-2" fill="white">
              <use xlinkHref={`#${id}`}></use>
            </mask>
            <use
              fill={color}
              transform="translate(23.002500, 11.998750) rotate(90.000000) translate(-23.002500, -11.998750) "
              xlinkHref={`#${id}`}
            ></use>
          </g>
        </g>
      </g>
    </svg>
  );
}
